import {RestResource} from '../rest'

import {ASSET_SERVER} from '../server'
import {athubAxios} from "@/util";

const location = new RestResource({server: ASSET_SERVER, resource: 'location'});

location.getByLocation = (location) => {
    let url = `${ASSET_SERVER}/location/${location}`;
    return athubAxios.get(url);
};

location.getLocationsByRoomId = (roomId) => {
    roomId = roomId == null ? '' : roomId;
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ASSET_SERVER}/location/queryAll?roomId=${roomId}`).then((response) => {
            if (response.status === 200) {
                resolve(response.data.data);
            } else {
                resolve(response.data.message);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

export default location;
